import HomePage from 'pages/home';
import NewsPage from 'pages/news-list';
import News from 'pages/news';
import PublicationPage from 'pages/publication';
import PublicationListPage from 'pages/publication-list';
import ResearcherPage from 'pages/researcher-page';
import ResearcherListPage from 'pages/researcher-list';
import CustomPage from 'pages/custom-page';
import SearchPage from 'pages/search';
import NotFound from 'pages/not-found';
import WorkAtYandexPage from 'pages/work-at-yandex';
import OutreachPage from 'pages/outreach';
import EventsPage from 'pages/events-page';
import ProjectsPage from 'pages/projects-page';
import DatasetsPage from 'pages/datasets-page';

/**
 * Роуты вынесены в отдельный файл, чтобы можно было по path
 * на сервере вытягивать у компонента метод asyncFetchData, в котором
 * подгружаются все необходимые данные для рендеренга страницы
 */
export default [
    {
        path: '/',
        component: HomePage,
        exact: true
    },
    {
        path: '/news/:slug',
        component: News,
        exact: true
    },
    {
        path: '/news',
        component: NewsPage,
        exact: true
    },
    {
        path: '/publications/:id',
        component: PublicationPage,
        exact: true
    },
    {
        path: '/publications',
        component: PublicationListPage,
        exact: true
    },
    {
        path: '/people/:id',
        component: ResearcherPage,
        exact: true
    },
    {
        path: '/people',
        component: ResearcherListPage,
        exact: true
    },
    {
        path: '/jobs',
        component: WorkAtYandexPage,
        exact: true
    },
    {
        path: '/pages/:slug',
        component: CustomPage,
        exact: true
    },
    {
        path: '/search',
        component: SearchPage,
        exact: true
    },
    {
        path: '/outreach',
        component: OutreachPage,
        exact: true
    },
    {
        path: '/outreach/events',
        component: EventsPage,
        exact: true
    },
    {
        path: '/outreach/projects',
        component: ProjectsPage,
        exact: true
    },
    {
        path: '/outreach/datasets',
        component: DatasetsPage,
        exact: true
    },
    {
        path: '*',
        component: NotFound,
        exact: true
    }
];
